import { getNextConfigValues } from 'next-config';
import { createAxiosClient } from 'src/utils/axiosClient';
import { isServerSide } from 'src/utils/next';

const {
  publicRuntimeConfig: { apiUrls },
  serverRuntimeConfig: { apiUrls: serverSideApiUrls },
} = getNextConfigValues();

const clientSideAuthClient = createAxiosClient({
  baseURL: `${apiUrls.railsRoot}auth/v1`,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

/**
 * Constructed lazily so we don't try to create a server-side instance on the
 * client (which would crash in the browser without serverRuntimeConfig set).
 */
const getServerSideAuthClient = () =>
  createAxiosClient({
    baseURL: `${serverSideApiUrls.railsRest}/auth/v1`,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  });

export const getAuthClient = () =>
  isServerSide() ? getServerSideAuthClient() : clientSideAuthClient;
